import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedConfig, SHARED_CONFIG } from '@emi/shared/models';

@NgModule({
    imports: [CommonModule],
})
export class SharedBuildersModule {
    static forRoot(config: SharedConfig): ModuleWithProviders<SharedBuildersModule> {
        return {
            ngModule: SharedBuildersModule,
            providers: [
                {
                    provide: SHARED_CONFIG,
                    useValue: config,
                },
            ],
        };
    }
}
